import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import AccountType from '@/constants/user/AccountType'
import Image from '@/models-ts/Image'
import Skill from '@/models-ts/Skill'
import Avatar from '@/models-ts/user/Avatar'
import { parseSlug } from '@/utils/parser'

export default class GigListItem {
  id: number
  slug: string
  type: number
  name: string
  banner: Image
  skills: Array<Skill>
  rate: string
  timeType: number
  timeValue: number
  userId: number
  userType: AccountType
  userName: string
  avatar: Avatar
  avgReview: string
  userReviews: number
  views?: number
  completedContractsCount?: number

  constructor(data: Partial<GigListItem>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.GigListItem) {
    return new GigListItem({
      id: data.id,
      slug: parseSlug(data.slug),
      type: data.type,
      name: unescape(data.name),
      banner: Image.fromServer(data.banners, { maxSize: 609 }),
      userId: data.user.id,
      userName: unescape(data.user.name),
      userType: data.user.type,
      avatar: Avatar.fromServer(data.user.avatar),
      avgReview: (data.user.profile.avg_reviews || 0).toFixed(2),
      userReviews: data.user.reviews_count,
      skills: (data.skills || []).map(Skill.fromServer),
      rate: data.rate,
      timeType: data.time_type,
      timeValue: data.time_value,
      views: data.views,
      completedContractsCount: data.completedContractsCount,
    })
  }
}
